import fetchRoute from "utils/routes";
import React from "react";
import { Icons, Spinner } from "cakemail-ui-components/lib/react";
import CakeStore from "assets/js/store";
import { isPartner } from "utils/apiUtils";
import Cookies from "universal-cookie";

export function getHashQueryWithoutHistory(returnObj = false) {
	let reactHistory = {};
	let manualQueryParam = null;

	if (returnObj) {
		manualQueryParam = window.location.hash.split("?")?.[1]?.split("&");

		if (manualQueryParam?.length > 0) {
			manualQueryParam.forEach((param) => {
				const queryParam = param.split("=");
				reactHistory[queryParam?.[0]] = queryParam?.[1];
			});
		}

		return reactHistory;
	}
	return "?" + window.location.hash.split("?")[1];
}

// decode html entities
function htmlDecode(input) {
	if (!input) {
		return null;
	}

	var doc = new DOMParser().parseFromString(input, "text/html");
	return doc.documentElement.textContent;
}

export function getUrlQueryParam(name) {
	const param = (
		new URLSearchParams(window.location.search).get(name) ||
		new URLSearchParams(getHashQueryWithoutHistory()).get(name) ||
		null
	)
	return htmlDecode(param);
}

export function isValidUrl(url) {
	if (
		/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(
			url
		)
	) {
		return true;
	}
	return false;
}

export function isValidImageUrl(url) {
	if (isValidUrl(url) && /\.(jpg|jpeg|png|gif|bmp|webp|svg)($|\?)/i.test(url)) {
		return true;
	}

	return false;
}

export function removeLegacyParameterByName(key) {
	const origin = window.location.origin;
	let params = new URLSearchParams(window.location.search);
	if (params.get(key)) {
		params.delete(key);
		params = params.toString();
		params = params ? "?" + params : "";

		const finalUrl = origin + "/" + params + window.location.hash;

		let obj = { Title: document.title, Url: finalUrl };

		history.pushState(obj, obj.Title, obj.Url);
	}
}

export function addLegacyParameter(name, value) {
	const origin = window.location.origin;
	let params = new URLSearchParams(window.location.search);
	if (params.get(name)) {
		params.set(name, value);
	} else {
		params.append(name, value);
	}
	params = params.toString();
	params = params ? "?" + params : "";

	const finalUrl = origin + "/" + params + window.location.hash;

	let obj = { Title: document.title, Url: finalUrl };

	history.pushState(obj, obj.Title, obj.Url);
}

export function setBackToFlow(url = null, newFlow = false) {
	if (newFlow && url) {
		const id = new Date().getTime();
		window.localStorage.setItem("flow_" + id, JSON.stringify([url]));
		addLegacyParameter("flowId", id);
		return;
	}

	const flowId = getUrlQueryParam("flowId");
	let flow = window.localStorage.getItem("flow_" + flowId);

	try {
		flow = JSON.parse(flow);
	} catch (error) {
		removeBackToFlow(flowId);
	}

	if (flow && url) {
		flow.push(url);
		window.localStorage.setItem("flow_" + flowId, JSON.stringify(flow));
	} else {
		removeBackToFlow(flowId);
	}
}

export function goBackToFlow(fallbackRoute = null, history = null) {
	const flowId = getUrlQueryParam("flowId");
	const finalFallback = fallbackRoute ? fallbackRoute : fetchRoute("dashboard");

	if (!flowId) {
		window.location = window.location.search + "#" + finalFallback;
		return;
	}

	let flow = window.localStorage.getItem("flow_" + flowId);

	try {
		flow = JSON.parse(flow);
	} catch (error) {
		removeBackToFlow(flowId);
	}

	if (flow?.length > 0) {
		if (history) {
			history.push(flow.pop());
		} else {
			window.location = window.location.search + "#" + flow.pop();
		}

		if (flow.length === 0) {
			removeBackToFlow(flowId);
		} else {
			window.localStorage.setItem("flow_" + flowId, JSON.stringify(flow));
		}
	} else {
		if (history) {
			history.push(finalFallback);
		} else {
			window.location = window.location.search + "#" + finalFallback;
		}
	}
}

export function removeBackToFlow(flowId = null) {
	const currentFlowId = getUrlQueryParam("flowId");
	if (currentFlowId && flowId == null) {
		window.localStorage.removeItem("flow_" + currentFlowId);
	} else {
		window.localStorage.removeItem("flow_" + flowId);
	}

	removeLegacyParameterByName("flowId");
}

export function clearBackToFlows() {
	let keys = Object.keys(window.localStorage);
	keys.forEach((key) => {
		if (/^flow_[0-9]+$/.test(key)) {
			window.localStorage.removeItem(key);
		}
	});
	removeLegacyParameterByName("flowId");
}

export const pagePeeker = {
	init: (memoizeImg) => {
		Object.keys(memoizeImg.current).forEach((key) => {
			const src = memoizeImg.current[key].src;
			if (memoizeImg.current[key].ready) {
				let el = document.getElementById(key);
				if (el && el.src !== src) el.src = src;
			} else {
				pagePeeker.fetchPagePeekerUrl(src, key, false, memoizeImg);
			}
		});
	},
	fetchPagePeekerUrl: (link, id, preFetch = false, memoizeImg) => {
		if (preFetch && !memoizeImg.current[id].hasFetched) {
			fetch(link).then(() => {
				if (memoizeImg.current[id]) {
					memoizeImg.current[id] = {
						...memoizeImg.current[id],
						hasFetched: true,
					};
				}
			});
		}

		function changeImg(isError = false) {
			if (memoizeImg.current[id]) {
				memoizeImg.current[id] = {
					...memoizeImg.current[id],
					ready: true,
				};
			}

			let el = document.getElementById(id);
			if (el) {
				if (el.src !== link) el.src = link;

				let parent = el.closest(".thumbnail.pagePeekerThumbnail.loading");
				if (parent) parent.classList.remove("loading");
				if (isError && parent) parent.classList.add("error");

				let spinner = document.getElementById(
					"spinner-link-img-" + id.substring(id.lastIndexOf("-") + 1)
				);
				if (spinner) spinner.classList.add("hidden");
			}

		}

		fetch(link.replace("thumbs", "thumbs_ready"))
			.then((res) => res.json())
			.then((res) => {
				if (res.IsReady) {
					changeImg();
				} else if (res.Error) {
					changeImg(true);
				} else {
					setTimeout(() => {
						pagePeeker.fetchPagePeekerUrl(link, id, true, memoizeImg);
					}, 2000);
				}
			})
			.catch(() => {
				changeImg(true);
			});
	},
	addImg: (index, url = null) => {
		if (url) {
			return (
				<div className="thumbnail pagePeekerThumbnail loading">
					<a href={url} rel="noreferrer" target="_blank">
						<img id={`link-img-${index}`} src={""} />
						<Icons name="glyph-block-image" />
					</a>
					<Spinner
						id={`spinner-link-img-${index}`}
						radius={20}
						strokeWidth={2}
						spinnerSpeed={1}
					/>
				</div>
			);
		}
		return (
			<div className="thumbnail pagePeekerThumbnail loading">
				<img id={`link-img-${index}`} src={""} />
				<Icons name="glyph-block-image" />
				<Spinner
					id={`spinner-link-img-${index}`}
					radius={20}
					strokeWidth={2}
					spinnerSpeed={1}
				/>
			</div>
		);
	},
	applyMemoize: (memoizeImg, index, url) => {
		if (!memoizeImg.current[`link-img-${index}`]) {
			let cleanedUrl = url;
			if (cleanedUrl.indexOf("?") > 0) {
				cleanedUrl = cleanedUrl.substring(0, cleanedUrl.indexOf("?"));
			}
			memoizeImg.current[`link-img-${index}`] = {
				ready: false,
				src:
					"https://api.pagepeeker.com/v2/thumbs.php?size=l&wait=61&url=" +
					cleanedUrl,
			};
		}
	},
};

export function getProfileLogoUrl(accountId) {
	return `https://s3.amazonaws.com/cm-persona-data-prod/oneXImg_${accountId}_logo.png?bust=${Math.floor(
		Math.random() * 100000000
	)}`;
}

export function getSDKLink(subPath = "", toConnect = false, redirectLink = null) {
	let brandRepoConfig = isPartner()
		? CakeStore.getState().brand?.client_config?.brand_repo
		: CakeStore.getState().userBrand?.client_config?.brand_repo;
	let sdkLink = `${process.env.BRAND_SDK_URL}/guided/${toConnect ? "auth" : "brand"
		}/${subPath}?return_url=${encodeURIComponent(
			redirectLink || window.location.href
		)}&destination=${CakeStore.getState().brand?.name}`;

	if (brandRepoConfig?.accountId) {
		sdkLink += "&accountId=" + brandRepoConfig?.accountId;
	}

	if (brandRepoConfig?.brandId) {
		sdkLink += "&brandId=" + brandRepoConfig?.brandId;
	}

	return sdkLink;
}

export function getOptInLink(addMoreInfo = false, listName = "") {
	let url =
		window.location.origin +
		"/#" +
		fetchRoute("listSubscription") +
		"?a=" +
		CakeStore.getState().global.account?.id;

	if (addMoreInfo) url += "&listName=" + listName + "&type=doptin";

	return url;
}

export function getUnsubLink() {
	return (
		window.location.origin +
		"/#" +
		fetchRoute("listUnsubscribe") +
		"?a=" +
		CakeStore.getState().global.account?.id
	);
}

export function getDOptInLink(addMoreInfo = false, listName = "") {
	let url =
		window.location.origin +
		"/#" +
		fetchRoute("listConfirmation") +
		"?a=" +
		CakeStore.getState().global.account?.id;

	if (addMoreInfo) url += "&listName=" + listName;

	return url;
}

export function getOptOutLink(addMoreInfo = false, listName = "") {
	let url =
		window.location.origin +
		"/#" +
		fetchRoute("listUnsubscribe") +
		"?a=" +
		CakeStore.getState().global.account?.id;

	if (addMoreInfo) url += "&listName=" + listName;

	return url;
}

export function preparePlausibleUrl() {
	const utms = getUtmCookies();
	const url = new URL(window.location.href);

	if (utms.utm_campaign) {
		url.searchParams.set("utm_campaign", utms.utm_campaign);
	}
	if (utms.utm_content) {
		url.searchParams.set("utm_content", utms.utm_content);
	}
	if (utms.utm_medium) {
		url.searchParams.set("utm_medium", utms.utm_medium);
	}
	if (utms.utm_source) {
		url.searchParams.set("utm_source", utms.utm_source);
	}
	return url.toString();
}

export function getUtmCookies() {
	const cookies = new Cookies();
	return {
		utm_campaign: cookies.get("utm_campaign"),
		utm_medium: cookies.get("utm_medium"),
		utm_source: cookies.get("utm_source"),
		utm_content: cookies.get("utm_content"),
	};
}

export function saveUtms() {
	const cookies = new Cookies();
	const utm_campaign = getUrlQueryParam("utm_campaign");
	const utm_medium = getUrlQueryParam("utm_medium");
	const utm_source = getUrlQueryParam("utm_source");
	const utm_content = getUrlQueryParam("utm_content");
	const maxAge = 60 * 60 * 24 * 7;
	if (utm_source) {
		cookies.set("utm_source", utm_source, { path: "/", maxAge: maxAge });
		cookies.set("utm_campaign", "", { path: "/", maxAge: maxAge });
		cookies.set("utm_medium", "", { path: "/", maxAge: maxAge });
		cookies.set("utm_content", "", { path: "/", maxAge: maxAge });
	}
	if (utm_campaign) {
		cookies.set("utm_campaign", utm_campaign, { path: "/", maxAge: maxAge });
	}
	if (utm_medium) {
		cookies.set("utm_medium", utm_medium, { path: "/", maxAge: maxAge });
	}
	if (utm_content) {
		cookies.set("utm_content", utm_content, { path: "/", maxAge: maxAge });
	}
}


export function getCurrentPathnameWithoutTemplateFilters(location) {
	return location.pathname
		.split("editor")[0]
		.split("usage")[0]
		.split("industry")[0]
		.split("seasonal")[0]
		.split("general")[0];
}

export function getBrandImage(property, brand = null) {
	if (!property) return "";

	let brandImages = brand ? brand?.images || brand : CakeStore.getState().brand?.images;
	let locale = CakeStore.getState().global?.user?.language?.toLowerCase();

	if (typeof property === "string" && brandImages?.[property + "_" + locale]) {
		return brandImages?.[property + "_" + locale]?.url || brandImages?.[property + "_" + locale];
	} else if (brandImages?.[property]) {
		return brandImages?.[property]?.url || brandImages?.[property];
	}
	//Old stuff for compatibility
	return property?.url || property;
}

export function kebabToCamel(str) {
	return str.replace(/-([a-z0-9])/g, (match) => {
		return match[1].toUpperCase();
	});
}

export function replaceHttp(string = "") {
	return string.replace(/https?:\/\//, '').replace(/\//g, "");
}